import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loading: boolean = false;

    beginLoading() {
        this.loading = true;
    }

    endLoading() {
        this.loading = false;
    }

    isLoading(): boolean {
        return this.loading;
    }
}
